import { JsonSchemaValidator } from "@common/json-schema-validator";
import { isNil, omitBy } from "lodash";
import {
  BrandBgEntityRaw,
  BrandCaptionLowerThirdEntityRaw,
  BrandEntityId,
  BrandLogoEntityRaw,
  BrandOverlayEntityRaw,
  RoomId,
  RoomOwnerId,
  RoomPid,
  RoomTitle
} from "../../interface";
import {
  brandBgEntityRaw,
  brandCaptionLowerThirdEntityRaw,
  brandEntityId,
  brandLogoEntityRaw,
  brandOverlayEntityRaw,
  roomDescription,
  roomId,
  roomIsDefault,
  roomIsLive,
  roomIsRecording,
  roomLiveAt,
  roomOwnerId,
  roomPid,
  roomStartAt,
  roomTitle
} from "../../schema";
import {
  RoomDescription,
  RoomIsDefault,
  RoomIsLive,
  RoomIsRecording,
  RoomLiveAt,
  RoomStartAt
} from "../../type";
import { BaseEntity } from "../base.entity";

export class RoomV2Entity extends BaseEntity<RoomV2EntityRaw> {
  private static validation = JsonSchemaValidator.compile(
    RoomV2Entity.schema()
  );

  static schema() {
    return {
      type: "object",
      required: [
        "id",
        "pid",
        "title",
        "ownerId",
        "isDefault",
        "isLive",
        "brandId",
        "isRecording"
      ],
      properties: {
        id: roomId,
        pid: roomPid,
        title: roomTitle,
        description: roomDescription,
        ownerId: roomOwnerId,
        isDefault: roomIsDefault,
        isLive: roomIsLive,
        liveAt: roomLiveAt,
        brandId: brandEntityId,
        brandBg: brandBgEntityRaw,
        brandCaptionLowerThird: brandCaptionLowerThirdEntityRaw,
        brandLogo: brandLogoEntityRaw,
        brandOverlay: brandOverlayEntityRaw,
        isRecording: roomIsRecording,
        startAt: roomStartAt
      },
      additionalProperties: false
    };
  }

  constructor(value: RoomV2EntityRaw) {
    super(
      JsonSchemaValidator.assert(
        RoomV2Entity.validation,
        omitBy(value, (_) => isNil(_))
      )
    );
  }
}

export interface RoomV2EntityRaw {
  id: RoomId;
  pid: RoomPid;
  title: RoomTitle;
  description?: RoomDescription;
  ownerId: RoomOwnerId;
  isDefault: RoomIsDefault;
  isLive: RoomIsLive;
  liveAt?: RoomLiveAt;
  brandId: BrandEntityId;
  brandBg?: BrandBgEntityRaw;
  brandCaptionLowerThird?: BrandCaptionLowerThirdEntityRaw;
  brandLogo?: BrandLogoEntityRaw;
  brandOverlay?: BrandOverlayEntityRaw;
  isRecording: RoomIsRecording;
  startAt?: RoomStartAt;
}
